module.exports = __webpack_public_path__ + "static/media/partner_gjdw.57c2216b.png";